import templateData from 'utils/template_data';


const addSIMsUrl = templateData('addSimsOrderUrl');
const quantity = templateData('quantity');
const organisation = templateData('organisation');
let rules = templateData('rules');
const csrfToken = templateData('csrfToken');

rules = JSON.parse(rules);

const selectBox = document.createElement('select');
selectBox.name = 'select_rule';
selectBox.id = 'select-rule';

function ruleListPopulate () {
  let option = new Option('--Select SIMs Rule--', '');
  selectBox.add(option);
  for (let rule of rules) {
    option = new Option(rule.name, rule.id);
    selectBox.add(option);
  }
}

ruleListPopulate();

function addAndSelectSimsRules (e, modal) {
  const messageWrapper = document.createElement('p');

  messageWrapper.innerHTML = `
    <form id="addSIMsForm" action="${addSIMsUrl}" method="post">
    <input type=hidden value="${csrfToken}" name="csrfmiddlewaretoken">
    <p>
    Are you sure you want to add <strong id="quantity"></strong> SIMs to <strong id="org"></strong>
    <br>
    This will charge additions and management fees
    </p>
    <div id="select-box"></div>
    </form>
  `;

  messageWrapper.querySelector('#quantity').innerText = quantity;
  messageWrapper.querySelector('#org').innerText = organisation;
  messageWrapper.querySelector('#select-box').appendChild(selectBox);

  modal.setState({
    body: messageWrapper.innerHTML,
    isDangerous: true,
  }, () => {
    $('#select-rule').select2({
      width: '75%',
      dropdownParent: $('#add-order-sims-modal'),
    });
  });
}


const addOrderSimsModal = {
  id: 'add-order-sims-modal',
  body: '',
  title: 'Add Order SIMs',
  isDangerous: true,
  confirmButtonText: 'Confirm',
  onOpen: addAndSelectSimsRules,
  onConfirm: () => {$('#addSIMsForm').submit();},
};

export default addOrderSimsModal;
